import { StyleSheet, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { HeaderBackButton, Text, spacing } from '@pletly/ui';

import { RootStackScreenProps } from '../../navigation/types';
import { withTranslation } from '../../locales/hoc';
import { InvitationsFromFamilyCaregivers } from './components/InvitationsFromFamilyCaregivers';

type Props = RootStackScreenProps<'Invitations'>;

export const InvitationsFromExternalCaregivers = withTranslation(
	({
		route: {
			params: { organisationUuid },
		},
	}: Props) => {
		const { t } = useTranslation();

		return (
			<View style={styles.container}>
				<View style={styles.header}>
					<HeaderBackButton />
					<Text category="h3">{t('connection-requests.title')}</Text>
				</View>
				<InvitationsFromFamilyCaregivers organisationUuid={organisationUuid} />
			</View>
		);
	},
);

const styles = StyleSheet.create({
	container: {
		paddingVertical: spacing(4),
		paddingHorizontal: spacing(2),
		maxWidth: 1280,
		marginHorizontal: 'auto',
		gap: spacing(10),
		width: '100%',
	},
	header: {
		alignItems: 'flex-start',
		gap: spacing(),
	},
});
